export enum PoliciesRoutePaths {
  root = 'policies',
  termsOfUse = 'terms-of-use',
  privacyNotice = 'privacy-notice',
  cookieNotice = 'cookie-notice',
  consumerHealthData = 'consumer-health-data',
}
